<script setup>
import { computed } from 'vue'
import { navigateToService, serviceMenuRoute } from '@/composables/navigator'
import { usePlanningStore } from '@/stores/planning.store'
import { useWebSiteStore } from '@/stores/web-site.store'

const props = defineProps({
  serviceId: { type: [Number, String], default: null },
  avatar: { type: String, default: null },
  short: { type: Boolean, default: false },
})

const planningStore = usePlanningStore()
const webSiteStore = useWebSiteStore()

const service = computed(() => planningStore.getServiceById(props.serviceId))
const name = computed(() => planningStore.getServiceName(service.value, props.short) || '')
const icon = computed(() => webSiteStore.getMenuIcon(serviceMenuRoute(service.value?.type)))

const navigate = () => {
  if (service.value) navigateToService(service.value)
}
</script>
<template>
  <a
    v-if="service"
    href="#"
    class="service-link"
    @click.stop.prevent="navigate"
  >
    <img v-if="avatar" :src="avatar" class="service-link__avatar">
    <i v-else-if="icon" :class="`mdi ${icon}`" />
    <span class="service-link__name">{{ name }}</span>
  </a>
  <span v-else />
</template>
<style scoped>
.service-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  overflow: hidden;
  text-decoration: none;
  color: var(--q-primary);
}
.service-link:hover {
  text-decoration: underline;
}
.service-link i {
  font-size: 1rem;
  flex-shrink: 0;
}
.service-link__avatar {
  width: 2rem;
  height: 2rem;
  object-fit: cover;
  border-radius: 50%;
  flex-shrink: 0;
}
.service-link__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
